import React from 'react';
import { FiClock, FiAlertTriangle } from 'react-icons/fi';

interface SLAIndicatorProps {
  hoursRemaining: number;
  slaExceeded: boolean;
}

const SLAIndicator: React.FC<SLAIndicatorProps> = ({
  hoursRemaining,
  slaExceeded,
}) => {
  if (slaExceeded) {
    return (
      <span className="sla-indicator sla-exceeded">
        <FiAlertTriangle className="me-1" />
        SLA Excedido
      </span>
    );
  }

  const isUrgent = hoursRemaining <= 12;
  const isWarning = hoursRemaining <= 24;

  const formatTime = (hours: number): string => {
    if (hours < 1) {
      const minutes = Math.round(hours * 60);
      return `${minutes}m`;
    }
    if (hours < 24) {
      return `${Math.round(hours)}h`;
    }
    const days = Math.floor(hours / 24);
    const remainingHours = Math.round(hours % 24);
    return remainingHours > 0 ? `${days}d ${remainingHours}h` : `${days}d`;
  };

  return (
    <span
      className={`sla-indicator ${isUrgent ? 'sla-urgent' : isWarning ? 'sla-warning' : 'sla-ok'}`}
    >
      <FiClock className="me-1" />
      {formatTime(hoursRemaining)} restantes
    </span>
  );
};

export default SLAIndicator;
